var i = Object.defineProperty;
var a = (s, e, t) => e in s ? i(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var r = (s, e, t) => a(s, typeof e != "symbol" ? e + "" : e, t);
import n from "axios";
import o from "axios-retry";
import { Socket as u } from "phoenix";
class y {
  constructor(e) {
    r(this, "host");
    r(this, "apiKey");
    r(this, "userToken");
    r(this, "axiosClient");
    r(this, "socket");
    this.host = e.host, this.apiKey = e.apiKey, this.userToken = e.userToken || null, this.axiosClient = n.create({
      baseURL: this.host,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.apiKey}`,
        "X-Knock-User-Token": this.userToken
      }
    }), typeof window < "u" && (this.socket = new u(`${this.host.replace("http", "ws")}/ws/v1`, {
      params: {
        user_token: this.userToken,
        api_key: this.apiKey
      }
    })), o(this.axiosClient, {
      retries: 3,
      retryCondition: this.canRetryRequest,
      retryDelay: o.exponentialDelay
    });
  }
  async makeRequest(e) {
    try {
      const t = await this.axiosClient(e);
      return {
        statusCode: t.status < 300 ? "ok" : "error",
        body: t.data,
        error: void 0,
        status: t.status
      };
    } catch (t) {
      return console.error(t), {
        statusCode: "error",
        status: 500,
        body: void 0,
        error: t
      };
    }
  }
  canRetryRequest(e) {
    return o.isNetworkError(e) ? !0 : e.response ? e.response.status >= 500 && e.response.status <= 599 || e.response.status === 429 : !1;
  }
}
export {
  y as default
};
//# sourceMappingURL=api.mjs.map
